export default __webpack_public_path__ + "static/media/lining19.7e6d75f5.jpg";